export default function($) {
  if ( $('.wpcf7-form .form-input-file-wrapper').length ) {

  	$('.wpcf7-form .form-input-file-wrapper').each( function() {
			var inputfile = $(this).find('.wpcf7-form-control-wrap input');

			var initfile = inputfile.val();

			if ( initfile != '' ) {
				var file = inputfile[0].files[0].name;
		  	inputfile.parent().siblings('.form-input-file-item').text(file);
			} else {
				inputfile.parent().siblings('.form-input-file-item').text('');
			}

			inputfile.on('change', function() {
		  	var file = inputfile[0].files[0].name;
		    $(this).parent().siblings('.form-input-file-item').text(file);
		  })

		  $('.wpcf7-form').submit(function(e){
		    e.preventDefault();
	  		inputfile.parent().siblings('.form-input-file-item').text('');
			});
  	})
  }
}
